// extracted by mini-css-extract-plugin
export default {"with-svg-core-badge":"_2qf_4","withSvgCoreBadge":"_2qf_4"};